import Vue from 'vue'
import VueResource from 'vue-resource';
import App from './App.vue'

const mergeWith = require('lodash.mergewith');

Vue.config.productionTip = false
Vue.use(VueResource)

export function init(produktDaten, optionen = {}) {
    var elMount = optionen.elementMount ? optionen.elementMount : '#app';

    const defaults = {
        modelBild: '',
        modelBildklasse: '',
        waehrung: '',
        modelHintergrund: '',
        texte: {
            cta_button: '',
            farbe: '',
            verfuegbar: '',
            gesamtpreis: '',
            grundpreis: '',
            title_add: '',
            mwst_versandkosten: '',
            title_remove: ''
        },
        ueberschrift: 'Shop The Look',
        subline: '',
        flagShop: true,
        flagMengeneingabe: false,
        flagNurProdukte: false,
    }

     optionen = mergeWith(
            defaults,
            optionen,
            (def, opt) => opt === '' ? def : undefined
        );

    new Vue({
        render: h => h(App, {
            props: {
                produktDaten,
                optionen
            }
        }),
    }).$mount(elMount);

}



// WEBPACK FOOTER //
// ./src/main.js